const theme = {
  primaryRed: '#e02020',
  red: '#DB2423',
  darkRed: '#811811',
  moreLightGray: '#f4f1ee',
  lightGray: '#C2C2C2',
  primaryGray: '#6E757C',
  mediumGray: '#707070',
  gray: '#707070',
  darkGray: '#212121',
  gradientGray: 'linear-gradient(124deg, #eae7e4 7%, #fcf9f5 86%)',
  gradientCream: 'linear-gradient(134deg, #fff0e2 4%, #fff8f2 54%, var(--ffffff) 85%)',
  gradientRed: 'linear-gradient(to bottom, var(--e-82727), #ff8456)',
  lightGreen: '#4edd53',
  green: '#03CF2E',
  lightYellow: '#ff973c',
  white: '#ffffff',
  black: '#000000',
  disableButton: '#f0d6d0',
}

export const breakpoint = {
  xs: 0,
  sm: '575.98px',
  md: '767.98px',
  lg: '991.98px',
  xl: '1199.98px',
  xxl: '1399.98px',
}

export const containerWidth = {
  sm: '540px',
  md: '720px',
  lg: '960px',
  xl: '1140px',
  xxl: '1320px',
}

export default theme
